import { createEmptyHistoryState } from "@lexical/react/LexicalHistoryPlugin";
import { useMemo, useState } from "react";
import type { SkedEditorHistory } from "./sked-caption-v2";
import { EditorState } from "lexical";

export const useSharedHistory = () => {
  const [historyState] = useState<SkedEditorHistory>(newSharedHistory());
  return [historyState];
};
export const useSharedHistoryMap = () => {
  const hMap = useMemo(() => {
    const map = new Map<string, SkedEditorHistory>();
    return {
      get(key: string) {
        if (!map.has(key)) {
          map.set(key, newSharedHistory());
        }
        return map.get(key)!;
      },
    };
  }, []);
  return [hMap];
};

function newSharedHistory(): SkedEditorHistory {
  return {
    historyState: createEmptyHistoryState(),
    lexicalState: null,
    caption: null,
    handleEditorChange(
      this: SkedEditorHistory,
      caption: string,
      state: EditorState
    ) {
      this.lexicalState = state;
      this.caption = caption;
    },
  };
}
